import React, {useEffect, useState } from 'react';
import { parse, format, setHours, setMinutes, setSeconds,getSeconds, getMinutes, getHours  } from 'date-fns';

const API_BASE_URL = process.env.REACT_APP_API_URL;

export async function getEventId(eventUrl) {
  try {
    const apiUrl = API_BASE_URL+'/events/getEventId?url='+eventUrl;
    const response = await fetch(apiUrl);
    if (!response.ok) console.error('Failed to fetch event ID');
    const data = await response.json();
    return data.EVENT_ID; 
  } catch (err) {
    throw err;
  }

}

export async function FetchEventInfo(eventId) {
  const apiUrl = API_BASE_URL+'/events/event?id='+eventId;

  const response = await fetch(apiUrl);
  if (!response.ok) {
    console.error('Network response was not ok');
  }
  const result = await response.json();
  return result;
}

export async function FetchAppSettings(eventId) {
  const apiUrl = API_BASE_URL+'/events/eventSettings?id='+eventId;
  
  const response = await fetch(apiUrl);
  if (!response.ok) {
    console.error('Network response was not ok');
  }
  const result = await response.json();
  return result;
}


export function checkDates({date},dateList) {

  let inDate = {date};
  let fDate = format(inDate.date, 'yyyy-MM-dd');
  if (dateList.includes(fDate)){
    return false   
  }
  else {
    return true
  }

}

export async function GetAvailableDates(eventId,promoCode,filterPromo) {
  const apiUrl = API_BASE_URL+'/events/getEventDates?id='+eventId+'&promocode='+promoCode+'&filterpromo='+filterPromo;
  
  const response = await fetch(apiUrl);
 
  if (!response.ok) {
    console.error('Network response was not ok');
  }
  
  const data = await response.json();
  return data;

}

export async function GetAvailableTimes(eventId,inDate,promoCode,filterPromo) {
  const timeDate = format(inDate, 'yyyy-MM-dd');
  const apiUrl = API_BASE_URL+'/events/getEventTimes?id='+eventId+'&date='+timeDate+'&promocode='+promoCode+'&filterpromo='+filterPromo;
  
  const response = await fetch(apiUrl);
 
  if (!response.ok) {
    console.error('Network response was not ok');
  }
  
  const data = await response.json();
  return data;

}

export async function GetAvailableTickets(eventId,DateAndTime,timeZone,promoCode,filterPromo) {

  const timeDate = format(DateAndTime, 'yyyy-MM-dd HH:mm:ss');
  const apiUrl = API_BASE_URL+'/events/getTickets?id='+eventId+'&date='+timeDate+'&timezone='+timeZone+'&promocode='+promoCode+'&filterpromo='+filterPromo;
  
  const response = await fetch(apiUrl);
 
  if (!response.ok) {
    console.error('Network response was not ok');
  }
  
  const data = await response.json();
  return data;

}

export async function GetAvailableReplacementTickets(eventId,DateAndTime,timeZone,promoCode,filterPromo) {

  const timeDate = format(DateAndTime, 'yyyy-MM-dd HH:mm:ss');
  const apiUrl = API_BASE_URL+'/events/getReplacementTickets?id='+eventId+'&date='+timeDate+'&timezone='+timeZone+'&promocode='+promoCode+'&filterpromo='+filterPromo;
  
  const response = await fetch(apiUrl);
 
  if (!response.ok) {
    console.error('Network response was not ok');
  }
  
  const data = await response.json();
  return data;

}

// API call to sync the cart contents with the server
export const syncCartToServer = async ({eventId,
                                        cartID, 
                                        promoCode, 
                                        cartContents, 
                                        charityId,
                                        charityAmt}) => {
      const apiUrl = API_BASE_URL+'/cart/setCartContents';
    
      try {
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            eventId:eventId,
            cartID: cartID,
            promoCode: promoCode,
            cartContents: cartContents,
            charityId:charityId,
            charityAmt:charityAmt
          }),
        });

      const rawText = await response.text();

if (!response.ok) {

  try {
    if (response.status === 400) {
      
      return null;
    }

    if (response.status === 422) {
      return null;
    }

    return null;
  } catch (innerError) {
    console.error('🔥 Exception inside response handler:', innerError);
    return null;
  }
}

      
        const data = JSON.parse(rawText);
        return data.data;
      } catch (error) {
        // Handle network or unexpected errors
        console.error('Error updating cart on server:', error);
        return null; // or handle appropriately
      }
};

export async function GetCartContents(cartId) {

    const apiUrl = API_BASE_URL+'/cart/getCartContents?cartid='+cartId;
    
    const response = await fetch(apiUrl);
 
    if (!response.ok) {
      console.error('Network response was not ok');
    }
    
    const data = await response.json();
    return data;
}


export function convertTo12HourFormat(time) {
    const [hour, minute] = time.split(':');
    const hourInt = parseInt(hour, 10);
    const suffix = hourInt >= 12 ? 'PM' : 'AM';
    const hour12 = hourInt % 12 || 12;  // Convert hour to 12-hour format
  
    return `${hour12}:${minute} ${suffix}`;
}

export async function GetAddOns(eventId) {
    const apiUrl = API_BASE_URL+'/cart/getAddOns?id='+eventId;
    const response = await fetch(apiUrl);
   
    if (!response.ok) {
      console.error('Network response was not ok');
    }
    
    const data = await response.json();
    return data;
  
  }
  
  export async function GetPasses(eventId) {
    const apiUrl = API_BASE_URL+'/cart/getPasses?id='+eventId;
    const response = await fetch(apiUrl);
   
    if (!response.ok) {
      console.error('Network response was not ok');
    }
    
    const data = await response.json();
    return data;
  
  }

  export async function GetClientSecret(event,currency,cartID,promocode) {
  
    const response = await fetch(API_BASE_URL+'/payments/getClientSecret', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({eventId:event,
        currency:currency,
        cartID:cartID,
        promocode:promocode || ''}),
    });
     
    if (!response.ok) {
      const errorText = await response.text(); // capture server error message
      throw new Error(`Error fetching client secret: ${errorText}`);
    }
    
    const data = await response.json();
    return data;
  
  }

  export async function SetFreeSecret(event,currency,cartID,promocode) {
  
    const response = await fetch(API_BASE_URL+'/payments/setClientSecret', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({eventId:event,
        currency:currency,
        cartID:cartID,
        promocode:promocode || ''}),
    });
     
    if (!response.ok) {
      const errorText = await response.text(); // capture server error message
      throw new Error(`Error fetching client secret: ${errorText}`);
    }
    
    const data = await response.json();
    return data;
  
  }

  export async function SubmitFreeOrder(orderInfo) {
    
    const response = await fetch(API_BASE_URL+'/submitOrder', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({orderInfo:orderInfo}),
    });
     
    if (!response.ok) {
      const errorText = await response.text(); // capture server error message
      throw new Error(`Error submitting order: ${errorText}`);
    }
    
    const data = await response.json();
    return data;
  
  }

  export async function GetPaymentIntent(event,paymentMethodId,stripeTotal,currency,cartID,promocode) {
  
    const response = await fetch(API_BASE_URL+'/payments/create-payment-intent', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ eventId:event,
                             paymentMethodId: paymentMethodId,
                             amount:stripeTotal,
                             currency:currency,
                             cartID,cartID,
                             promocode:promocode || ''}),
    });
     
    if (!response.ok) {
      console.error('Network response was not ok');
    }
    
    const data = await response.json();
    return data;
  
  }

  export async function ValidatePromoCode(eventId,promoCode) {
    const apiUrl = API_BASE_URL+'/cart/validatePromoCode?id='+eventId+'&code='+promoCode;
    const response = await fetch(apiUrl);
   
    if (!response.ok) {
      console.error('Network response was not ok');
    }
    const data = await response.json();
    return data;
  

  }

  export async function validateEmail(email,eventId) {
    const apiUrl = API_BASE_URL+'/account/accountLogin';

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email:email,
          eventId:eventId
        }),
      });
    
      if (!response.ok) {
        // Handle HTTP errors
        console.error(`Server returned error status: ${response.status}`);
        if (response.status === 400) {
          console.error('Bad Request: Check your payload or API logic.');
          return null; // or any default value to indicate failure
        }

      }
    
      const data = await response.json();
      return data.data;
    } catch (error) {
      // Handle network or unexpected errors
      console.error('Error on server:', error);
      return null;
    }
  }

  export async function validateCode(email,eventId,validationCode) {
    const apiUrl = API_BASE_URL+'/account/accountValidation';
    
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email:email,
          eventId:eventId,
          validationCode:validationCode
        }),
      });
    
      if (!response.ok) {
        // Handle HTTP errors
        console.error(`Server returned error status: ${response.status}`);
        if (response.status === 400) {
          console.error('Bad Request: Check your payload or API logic.');
          return null; // or any default value to indicate failure
        }

      }
    
      const data = await response.json();
      return data.data;
    } catch (error) {
      // Handle network or unexpected errors
      console.error('Error on server:', error);
      return null;
    }
  }

  export async function getCustomerData(token) {
    const apiUrl = API_BASE_URL+'/account/accountInfo';
    
    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          "Content-Type": "application/json"},
      });
    
      if (!response.ok) {
        // Handle HTTP errors
        console.error(`Server returned error status: ${response.status}`);
        return response.status;
        if (response.status === 400) {
          console.error('Bad Request: Check your payload or API logic.');
          return null; // or any default value to indicate failure
        }

      }
    
      const data = await response.json();
      return data.data;
    } catch (error) {
      // Handle network or unexpected errors
      console.error('Error on server:', error);
      return null;
    }
  }

  export async function getCustomerOrders(token) {
    const apiUrl = API_BASE_URL+'/account/accountOrders';
    
    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          "Content-Type": "application/json"},
      });
    
      if (!response.ok) {
        // Handle HTTP errors
        console.error(`Server returned error status: ${response.status}`);
        if (response.status === 400) {
          console.error('Bad Request: Check your payload or API logic.');
          return null; // or any default value to indicate failure
        }

      }
    
      const data = await response.json();
      return data.data;
    } catch (error) {
      // Handle network or unexpected errors
      console.error('Error on server:', error);
      return null;
    }
  }

  export async function getOrderDetails(token,order_num) {
    const apiUrl = API_BASE_URL+'/account/accountOrder?orderId='+order_num;
    
    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          "Content-Type": "application/json"},
      });
    
      if (!response.ok) {
        // Handle HTTP errors
        console.error(`Server returned error status: ${response.status}`);
        return response.status;

      }
    
      const data = await response.json();
      return data.data;
    } catch (error) {
      // Handle network or unexpected errors
      console.error('Error on server:', error);
      return null;
    }
  }

  export async function getAccountFees(token,eventId) {
    const apiUrl = API_BASE_URL+'/account/accountFees?eventId='+eventId;
    
    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          "Content-Type": "application/json"},
      });
    
      if (!response.ok) {
        // Handle HTTP errors
        console.error(`Server returned error status: ${response.status}`);
        return response.status;

      }
    
      const data = await response.json();
      return data.data;
    } catch (error) {
      // Handle network or unexpected errors
      console.error('Error on server:', error);
      return null;
    }
  }

  export async function resendOrder(token,orderId,eventId) {
    const apiUrl = API_BASE_URL+'/account/resendOrder?orderId='+orderId+'&eventId='+eventId;
    
    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          "Content-Type": "application/json"},
      });
    
      if (!response.ok) {
        // Handle HTTP errors
        console.error(`Server returned error status: ${response.status}`);
        return response.status;

      }
    
      const data = await response.json();
      return data;
      
    } catch (error) {
      // Handle network or unexpected errors
      console.error('Error on server:', error);
      return null;
    }
  }


  export async function GetCartId(cartId) {
    const apiUrl = API_BASE_URL+'/cart/getCartId?id='+cartId;
    const response = await fetch(apiUrl);
   
    if (!response.ok) {
      console.error('Network response was not ok');
    }
    
    const data = await response.json();
    
    return data;
  
  }

  export async function GetLegend(eventId) {
    const apiUrl = API_BASE_URL+'/events/getLegend?id='+eventId;
    const response = await fetch(apiUrl);
   
    if (!response.ok) {
      console.error('Network response was not ok');
    }
    
    const data = await response.json();
    
    return data;
  
  }

export async function GetServiceFees(eventId) {
  const apiUrl = API_BASE_URL + '/cart/getServiceFees?id=' + eventId;

  try {
    const response = await fetch(apiUrl);

    if (!response.ok) {
      console.error('Error fetching service fees:', response.statusText);
      return null;
    }

    const data = await response.json();
    return data;

  } catch (error) {
    console.error('Fetch error in GetServiceFees:', error);
    return null;
  }
}

export async function GetCharity(eventId) {
  const apiUrl = `${API_BASE_URL}/cart/getCharity?id=${eventId}`;
  const response = await fetch(apiUrl);
  if (!response.ok) return null;
  const data = await response.json();
  return Object.keys(data).length > 0 ? data : null;
}

// Per-ticket price including service fee — mirrors the fee rules in Cart.jsx calcTotals()
export function getAllInPrice(price, ticketType, fees) {
  const p = Number(price) || 0;
  if (p <= 0 || ticketType === 4 || !fees?.length) return p;

  const fee = fees.find(f => Number(f.EF_TICKET_TYPE) === Number(ticketType));
  if (!fee) return p;

  const amt = Number(fee.EF_FEE_AMOUNT) || 0;
  if (fee.EF_FEE_TYPE === 1) return p + amt;            // flat $ per ticket
  if (fee.EF_FEE_TYPE === 2) return p + (p * amt) / 100; // % of ticket price
  return p;
}

